export default {
  VUE_APP_BASE_URL: process.env?.VUE_APP_BASE_URL,
  API_BASE_URL: process.env.VUE_APP_API_BASE_URL,
};
